import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
	selector: '[passengerCanSign]',
})
export class PassengerCanSignDirective implements OnInit {
	@Input() passengerCanSign: any;
	@Input() requiredDocuments;
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - constructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor(private el: ElementRef) {}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - ngOnInit
	 **-------------------------------------------------------------------------------------
	 */
	ngOnInit(): void {
		const canSign = this.canPassengerSign();
		this.el.nativeElement.disabled = canSign;
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME -
	 **-------------------------------------------------------------------------------------
	 */
	public canPassengerSign(): boolean {
		const passenger = this.passengerCanSign;
		const forms = this.requiredDocuments[passenger.type];
		const neededForms = forms.filter(key => {
			if (passenger.documents[key]) return false;
			return true;
		});
		return neededForms.length > 0 ? true : false;
	}
}
